/*-----------------------------------------------------------------
- Components translations
-----------------------------------------------------------------*/

export default {
    
    dropzone: {
        
        drag: {
            single  : 'فایل را اینجا رها کنید!',
            multiple: 'فایل‌ها را اینجا رها کنید!',
        },
        
        button: {
            small   : 'انتخاب فایل',
            single  : 'یا فایل خود را انتخاب کنید',
            multiple: 'یا فایل‌های خود را انتخاب کنید',
        },
        
        add: 'افزودن فایل',
        
    },
    
    select: {
        placeholder      : 'از میان گزینه‌ها انتخاب کنید.',
        placeholderSearch: 'انتخاب کنید یا جستجو نمایید.',
    },
    
    images: {
        empty: 'فایل ضمیمه‌ای یافت نشد!',
    },
    
};
